import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import { DELIVERY_METHOD_UNAVAILABLE_MESSAGE } from 'Component/CheckoutDeliveryOption/CheckoutDeliveryOption.config';
import TextPlaceholder from 'Component/TextPlaceholder';
import { ShippingMethodType } from 'Type/Checkout.type';

import './DeliveryOption.style';

/** @namespace PeggysagePwa/Component/DeliveryOption/Component */
export class DeliveryOptionComponent extends PureComponent {
    static propTypes = {
        option: ShippingMethodType.isRequired,
        defaultCountry: PropTypes.string.isRequired,
        getOptionPrice: PropTypes.func.isRequired
    };

    renderRate() {
        const {
            option: {
                method_title,
                available
            } = {}
        } = this.props;

        if (!available) {
            return null;
        }

        return (
            <span block="DeliveryOption" elem="Rate">
                <strong>{ method_title }</strong>
            </span>
        );
    }

    renderDeliveryDate() {
        const { option: { delivery_date } = {} } = this.props;

        if (!delivery_date) {
            return null;
        }

        return (
            <span block="DeliveryOption" elem="DeliveryDate">{ delivery_date }</span>
        );
    }

    renderPrice() {
        const {
            option: {
                available
            } = {},
            getOptionPrice
        } = this.props;

        if (!available) {
            return null;
        }

        return (
            <span block="DeliveryOption" elem="Price">
                <strong>{ getOptionPrice() }</strong>
            </span>
        );
    }

    renderAvailabilityMessage() {
        const {
            option: {
                available
            } = {}
        } = this.props;

        if (available) {
            return null;
        }

        if (available === undefined) {
            return (
                <>
                    <TextPlaceholder length="long" />
                    <TextPlaceholder length="medium" />
                    <TextPlaceholder length="short" />
                    <TextPlaceholder length="medium" />
                </>
            );
        }

        return (
            <div block="DeliveryOption" elem="Message">
                { DELIVERY_METHOD_UNAVAILABLE_MESSAGE }
            </div>
        );
    }

    render() {
        const {
            option: {
                method_code,
                carrier_code,
                carrier_title
            } = {},
            defaultCountry
        } = this.props;

        return (
            <div block="DeliveryOption">
                <div block="DeliveryOption" elem="Visual">
                        <span
                          data-carrier={ carrier_code }
                          data-medthod={ method_code }
                          data-country={ defaultCountry }
                        >
                            <strong>{ carrier_title }</strong>
                        </span>
                </div>
                <div block="DeliveryOption" elem="Details">
                    { this.renderRate() }
                    { this.renderDeliveryDate() }
                    { this.renderPrice() }
                    { this.renderAvailabilityMessage() }
                </div>
            </div>
        );
    }
}

export default DeliveryOptionComponent;
